import { render, staticRenderFns } from "./kv-floating-action-bar.vue?vue&type=template&id=b38b8332&scoped=true"
import script from "./kv-floating-action-bar.vue?vue&type=script&lang=js"
export * from "./kv-floating-action-bar.vue?vue&type=script&lang=js"
import style0 from "./kv-floating-action-bar.vue?vue&type=style&index=0&id=b38b8332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38b8332",
  null
  
)

export default component.exports